export default __webpack_public_path__ + "static/media/3004.78be4897.jpg";